import React from "react";
import PropTypes from "../../utils/propTypes";
import {canUseWebP} from "../../utils/Utilities";

class Image extends React.Component{

    render() {
    let {src} = this.props
    let {noWebp} = this.props
    if(src){
        if(src && src.includes("base64")){
            // Base 64 nothing to do
        }else{
            if(!noWebp){
                if(canUseWebP()){
                    src = src+"?webp=true"
                }else{
                    src = src+"?webp=false"
                }
            }
        }
    }
    return(
        <img{...this.props} src={src}/>
    )
    }
}
Image.propTypes = {
    style: PropTypes.any,
    src: PropTypes.string,
    className:PropTypes.any,
    noWebp:PropTypes.bool,
};


export default Image